import * as React from 'react';

import { RatePlanViewModel } from 'models';

import { UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkTextSkeleton } from 'uitk-react-skeleton';

import { RatePlanFragment } from '__generated__/api';
import { RoomRateOptionsProps } from 'components/infosite/rooms-and-rates/room-rate-options';
import { RoomReserveForm } from 'components/infosite/rooms-and-rates/reserve-form';

import LodgingFormInlineFragment = RatePlanFragment.LodgingFormInlineFragment;

export interface SSRRatePlanViewWithReserveButtonProps extends RoomRateOptionsProps {
  index: number;
  ratePlan: RatePlanViewModel;
}

export const SSRRatePlanViewWithReserveButton: React.FC<SSRRatePlanViewWithReserveButtonProps> = ({
  index,
  isPinnedRatePlan,
  isUnavailable,
  optionBaseIndex,
  position,
  ratePlan,
  room,
  trackingRfrr,
}: SSRRatePlanViewWithReserveButtonProps) => {
  const { bookingLabel, paymentPlans, ratePlanCode, valueAddPromotion, dataAttributes, reserveCallToAction } = ratePlan;

  const lodgingForm = paymentPlans?.[0]?.offerBookButton || (reserveCallToAction as LodgingFormInlineFragment);

  const option = index + optionBaseIndex + 1;
  const formProps = {
    paymentPlan: paymentPlans?.[0], // By default, only render first payment plan for server-side
    ratePlanCode,
    room,
    formAction: room.udpUrl,
    rfrr: `${trackingRfrr || ''}.RoomsAndRates.BookButton.Room${position}.Rate${option}`,
    isPinnedRatePlan,
    valueAddPromotion,
    option,
    label: bookingLabel,
    dataAttributes: dataAttributes?.reserveButton || {},
    lodgingForm,
  };

  return (
    <UitkCardTextSegment
      className={`${index > 0 ? 'uitk-card-separator-top' : ''}`}
      key={`rate-plan-${option}`}
      data-stid="section-rateplan"
    >
      <SkeletonPlaceHolders />
      {!isUnavailable && <RoomReserveForm {...formProps} />}
    </UitkCardTextSegment>
  );
};
SSRRatePlanViewWithReserveButton.displayName = 'SSRRatePlanViewWithReserveButton';

export const SkeletonPlaceHolders: React.FC = () => (
  <>
    <UitkCardContent className="uitk-flex uitk-flex-wrap uitk-flex-justify-content-space-between uitk-flex-gap-two all-b-padding-two">
      <UitkTextSkeleton className="uitk-cell all-cell-1-3" />
      <UitkTextSkeleton className="uitk-cell all-cell-1-4" />
    </UitkCardContent>
    <UitkCardContent className="uitk-flex uitk-flex-wrap uitk-flex-justify-content-space-between uitk-flex-gap-two all-b-padding-six">
      <UitkTextSkeleton className="uitk-cell all-cell-1-2" />
      <UitkTextSkeleton className="uitk-cell all-cell-1-3" />
    </UitkCardContent>
  </>
);
